<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-5 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">
          {{ "Add Project" }}
        </div>

        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="text"
              placeholder="Project Name*"
              v-model="projectName"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>

        <div class="mt-2 text-gray-800 my-auto flex flex-col">
          <div
            v-for="(annotationField, index) in annotationFieldList"
            :key="index"
            class="flex flex-row"
          >
            <AddProjectInputDetails
              :annotationField="annotationField"
            ></AddProjectInputDetails>

            <div class="flex justify-start ml-2 mt-4">
              <button
                type="button"
                class="ml-2 rounded-md border text-white"
                style="background-color: #e40046; width: 90px; height: 30px"
                @click="remove(index)"
                v-show="annotationFieldList.length > 1"
              >
                Remove
              </button>
            </div>
          </div>
          <button
            type="button"
            class="mt-2 justify-start rounded-md border text-white"
            style="background-color: #e40046; width: 140px; height: 30px"
            @click="addMore()"
          >
            Add More Fields
          </button>
        </div>

        <div class="w-full flex justify-end p-3 cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              :disabled="
                projectName.length == 0 || annotationFieldList.length == 0
              "
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('addProject', projectName, annotationFieldList)"
            >
              Add Project
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import InputTag from "vue-input-tag";
import AddProjectInputDetails from "./addProjectInputDetails.vue";
export default {
  props: {
    projectData: Object,
  },

  //   components: {
  //     InputTag,
  //   },
  components: {
    AddProjectInputDetails,
  },
  data() {
    return {
      projectName: "",
      annotationFieldList: [
        {
          fieldName: "",
          fieldColor: "",
        },
      ],
    };
  },

  created() {},

  methods: {
    addMore() {
      this.annotationFieldList.push({
        fieldName: "",
        fieldColor: "",
      });
    },
    remove(index) {
      this.annotationFieldList.splice(index, 1);
    },
  },
};
</script>

<style>
button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}

/* Multiple input styling */
.vue-input-tag-wrapper {
  border: none !important;
}

.input-tag {
  background-color: #e40046 !important;
  border-color: #e40046 !important;
  color: white !important;
  border-radius: 2px !important;
}

.vue-input-tag-wrapper .new-tag {
  font-size: 15px !important;
  line-height: 24px !important;
}

.remove {
  color: black !important;
}

/* END */
</style>
